export default __webpack_public_path__ + "static/media/goshen55.6d6adace.JPG";